import { OpportunityUserUserRoleView, UserRoleView } from '@api-proxies';
import { UserRoleService } from '@http/clients/user-role.service';
import { UserRoleEntity } from './abstract/user-role-entity';

export class OpportunityUserRoleEntity extends UserRoleEntity<OpportunityUserUserRoleView> {
    constructor(userRoleService: UserRoleService) {
        super(userRoleService);
    }

    toDestination(entity: UserRoleView): OpportunityUserUserRoleView {
        return {
            id: 0,
            opportunityUserId: 0,
            userRoleId: entity.id,
            userRoleCode: entity.code,
            userRoleDescription: entity.description
        };
    }

    toSource(entity: OpportunityUserUserRoleView): UserRoleView {
        return {
            id: entity.userRoleId,
            code: entity.userRoleCode,
            description: entity.userRoleDescription,
            userOrganizations: [],
            users: []
        };
    }

    async getSource(): Promise<UserRoleView[]> {
        return await this.userRoleService.getAll();
    }
}
